import * as ko from "knockout";
import {DLFEmployee} from "../Models/Employee/DLFEmployee";
export class ContactViewModel <T extends DLFEmployee> {
    isLoading = ko.observable<boolean>(true);
    consultant = ko.observable<DLFEmployee>();

}